// src/features/badges/redux/constants.js
export const FETCH_CATEGORIES = "FETCH_CATEGORIES";
export const FETCH_CATEGORIES_SUCCESS = "FETCH_CATEGORIES_SUCCESS";
export const FETCH_CATEGORIES_ERROR = "FETCH_CATEGORIES_ERROR";
export const CREATE_CATEGORIES = "CREATE_CATEGORIES";
export const CREATE_CATEGORIES_SUCCESS = "CREATE_CATEGORIES_SUCCESS";
export const CREATE_CATEGORIES_ERROR = "CREATE_CATEGORIES_ERROR";
export const UPDATE_CATEGORIES = "UPDATE_CATEGORIES";
export const UPDATE_CATEGORIES_SUCCESS = "UPDATE_CATEGORIES_SUCCESS";
export const UPDATE_CATEGORIES_ERROR = "UPDATE_CATEGORIES_ERROR";
export const IS_ADDING_UPDATE = "IS_ADDING_UPDATE";
export const SET_BADGES_MANAGER_STATE = "SET_BADGES_MANAGER_STATE";
